import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _awaitAsyncGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _wrapAsyncGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
import _asyncIterator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncIterator";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(sync);

import take from "./take.js";
import toArray from "../toArray.js";
import { asyncEmpty, empty, isAsyncIterable, isIterable } from "../_internal/utils.js";
import concurrent, { isConcurrent } from "./concurrent.js";

function sync(size, iterable) {
  var iterator, c;
  return _regeneratorRuntime.wrap(function sync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          iterator = iterable[Symbol.iterator]();

        case 1:
          if (!true) {
            _context.next = 10;
            break;
          }

          c = toArray(take(size, _defineProperty({}, Symbol.iterator, function () {
            return iterator;
          })));

          if (!(c.length > 0)) {
            _context.next = 6;
            break;
          }

          _context.next = 6;
          return c;

        case 6:
          if (!(c.length < size)) {
            _context.next = 8;
            break;
          }

          return _context.abrupt("return");

        case 8:
          _context.next = 1;
          break;

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function asyncSequential(_x, _x2) {
  return _asyncSequential.apply(this, arguments);
}

function _asyncSequential() {
  _asyncSequential = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(size, iterable) {
    var i, items, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator2, _step, item;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            i = 0;
            items = [];
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 4;
            _iterator2 = _asyncIterator(iterable);

          case 6:
            _context2.next = 8;
            return _awaitAsyncGenerator(_iterator2.next());

          case 8:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 19;
              break;
            }

            item = _step.value;

            if (i++ < size) {
              items.push(item);
            }

            if (!(i === size)) {
              _context2.next = 16;
              break;
            }

            _context2.next = 14;
            return items;

          case 14:
            i = 0;
            items = [];

          case 16:
            _iteratorAbruptCompletion = false;
            _context2.next = 6;
            break;

          case 19:
            _context2.next = 25;
            break;

          case 21:
            _context2.prev = 21;
            _context2.t0 = _context2["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 25:
            _context2.prev = 25;
            _context2.prev = 26;

            if (!(_iteratorAbruptCompletion && _iterator2.return != null)) {
              _context2.next = 30;
              break;
            }

            _context2.next = 30;
            return _awaitAsyncGenerator(_iterator2.return());

          case 30:
            _context2.prev = 30;

            if (!_didIteratorError) {
              _context2.next = 33;
              break;
            }

            throw _iteratorError;

          case 33:
            return _context2.finish(30);

          case 34:
            return _context2.finish(25);

          case 35:
            if (!items.length) {
              _context2.next = 38;
              break;
            }

            _context2.next = 38;
            return items;

          case 38:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[4, 21, 25, 35], [26,, 30, 34]]);
  }));
  return _asyncSequential.apply(this, arguments);
}

function async(size, iterable) {
  var _iterator;

  return _defineProperty({
    next: function next(_concurrent) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_iterator === undefined) {
                  _iterator = isConcurrent(_concurrent) ? asyncSequential(size, concurrent(_concurrent.length, iterable)) : asyncSequential(size, iterable);
                }

                return _context3.abrupt("return", _iterator.next(_concurrent));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, Symbol.asyncIterator, function () {
    return this;
  });
}

function chunk(size, iterable) {
  if (iterable === undefined) {
    return function (iterable) {
      return chunk(size, iterable);
    };
  }

  if (isIterable(iterable)) {
    if (size < 1) {
      return empty();
    } else {
      return sync(size, iterable);
    }
  }

  if (isAsyncIterable(iterable)) {
    if (size < 1) {
      return asyncEmpty();
    } else {
      return async(size, iterable);
    }
  }

  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}

export default chunk;